import { render, staticRenderFns } from "./WaimaiPop.vue?vue&type=template&id=2cbd1f6e"
import script from "./WaimaiPop.vue?vue&type=script&lang=js"
export * from "./WaimaiPop.vue?vue&type=script&lang=js"
import style0 from "./WaimaiPop.vue?vue&type=style&index=0&id=2cbd1f6e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports